<template>
    <div class="base-bg">
      <div class="nav-bar">
        <div class="btn-wrapper">
          <blue-btn info="返回" v-bind:handle-click="cancel"></blue-btn>
        </div>
      </div>
      <div class="content-block">
        <!-- <div class="desc-block">
          <p>课程说明</p>
          <card-view>
            <textarea slot="content" type="text"
                      v-model="body"
                      readonly></textarea>
          </card-view>
  
        </div> -->
  
        <div class="desc-block img-block">
          <p>课程签到</p>
          <div class="images">
            <card-view>
                <div slot="content" class="faBox">
                  <template v-if="$route.params.signStatus=='0'">
                      <!-- 两张图 一张课程签到图  一张生成签名的课程图  都可以查看大图 -->
                      <div class="box">
                          <div class="image">
                              <img 
                                  style="width: 100%; height: 100%; border-radius: 10px;"
                                  :src="bgPic" 
                                  @click="showPreview"/>
                          </div>
                          <div class="textQian">
                            <span>签字后>></span>
                          </div>
                          <div class="image">
                            <img 
                                  style="width: 100%; height: 100%; border-radius: 10px;"
                                  :src="makePic" 
                                  @click="showPreview1"/>
                          </div>
                      </div>
                      <div class="boxEsign">
                        <vue-esign ref="esign" style="border: 1px solid black; margin-top:5px; width: 100%; height: 100%;" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
                      </div>
                      <div class="btn">
                        <el-button size="mini" @click="handleReset">清空画板</el-button>
                        <el-button size="mini" @click="drawProdPicture">完成签字</el-button>
                      </div>
                  </template>
                  <template v-else>
                    <img 
                      style="width: 100%; height: 100%; border-radius: 10px;"
                      :src="makePic" 
                      @click="showPreview1"/>
                  </template>
                </div>
            </card-view>
            <template v-if="$route.params.signStatus=='0'">
              <div class="btn-wrapper2">
                <blue-btn info="提交" v-bind:handle-click="submit"></blue-btn>
              </div>
            </template>
          
          </div>
        </div>
      </div>
  
  
    </div>
  </template>
  
  <script>
    import {mapState} from "vuex"
    import BlueBtn from '../components/BlueBtn.vue';
    import CardView from '../components/CardView.vue';
    // import Qiniu from 'Qiniu';
    // import PostMsg from '../api/postmsg';
    import MyClass from '../api/myclass';
    import { Toast, Indicator } from 'mint-ui';
    import { ImagePreview} from 'vant';
    export default{
      name: 'signature',
      data () {
        return {
          maxImages: 9,
          upToken: '',
          upLoader: '',
          files: [],
          headerFileLength: 0,
          lineWidth: 6,
          lineColor: '#000000',
          bgColor: '',
          isCrop: false,
          //底图
          bgPic:'',
          //签名图
          resultImg: '',
          //查看大图
          makePic:'', //合并的签字图
        };
      },
      components: {BlueBtn, CardView},
      created() {
        //清空签字图和大图
        this.makePic=''
        this.bgPic=''
      
      },
      mounted(){
          //判断是否签字，对图片赋值显示
          if(this.$route.params.signStatus=='0'){
            this.$refs.esign.reset();  //签字区重置
            this.bgPic=this.SelectSignature     //未签字页面的原图片
          }else{
            this.makePic=this.SelectSignature //查看已签字的签字照片
          }
      },
      methods: {
        showPreview() {
          // 调用 ImagePreview 的静态方法，传入图片列表
          ImagePreview([this.bgPic]);
        },
        showPreview1(){
          // 调用 ImagePreview 的静态方法，传入图片列表
          ImagePreview([this.makePic]);
        },
        //清空画板
        handleReset () {
          this.$refs.esign.reset();
          this.makePic=''
        },
        drawProdPicture() {
          // 先生成签字图 resultImg 存储
          this.$refs.esign.generate().then(res => {
            this.resultImg = res;
            // 存储完签名图后进行和签到图合成
            // 底图 img1（原图）
            let img1 = new Image();
            img1.src = this.bgPic;
            img1.setAttribute('crossOrigin', 'anonymous'); // 解决跨域访问图片的限制。

            // 将原图 img1 加入画布
            img1.onload = () => {
              let canvas = document.createElement("canvas"); // 创建了一个新的 <canvas> 元素
              let context = canvas.getContext("2d"); // 使用 getContext 方法获取了 2d 上下文
              context.canvas.willReadFrequently = true; //这样可以告诉浏览器，我们将频繁读取图像数据，从而提高性能。
              canvas.width = img1.width;
              canvas.height = img1.height;
              context.drawImage(img1, 0, 0, img1.width, img1.height);

              // 生成签名照片合并位置和展示大小
              let img2 = new Image();
              img2.src = this.resultImg;
              img2.setAttribute('crossOrigin', 'anonymous');
              img2.width = 120 //签名照的宽度
              img2.height = 50//签名照的高度
              // 将 img2 加入画布 签名照
              img2.onload = () => {
                
                let x = img1.width - img2.width-80;// 计算签名照片在画布中的 x 坐标
                let y = 0; // 签名照片在画布中的 y 坐标
                context.drawImage(img2, x, y, img2.width, img2.height);

                let src = canvas.toDataURL('image/png');
                this.makePic = src;
              }
            }
          }).catch(err => {
            this.toastMsg('请签字！');
          });
        },
        cancel () {
          this.$router.goBack();
        },
        submit () {
          if(this.makePic!=''){
            const fileData = new FormData();
            var binaryData = this.base64ToBinary(this.makePic);
            fileData.append('file',binaryData)
            //区分是自定义签字还是正常签字
            if(this.$route.params.isCustom=='false'){
              //添加原图
              fileData.append('artworkMaster',this.bgPic)
              //提交
              MyClass.SubmitSignatureImage(fileData).then(response=>{
                if(response.code==0){
                  this.toastMsg('签字成功！');
                  this.cancel()
                }else{
                  this.toastMsg(response.msg)
                }
              }).catch((err)=>{
                this.toastMsg(err)
              })
            }else{
              //添加id
              fileData.append('id',this.$store.state.SelectSignature.CustomSignatureId)
              //自定义图片提交
              MyClass.SubmitCustomSignatureImage(fileData).then(response=>{
                if(response.code==0){
                  this.toastMsg('签字成功！');
                  this.cancel()
                }else{
                  this.toastMsg(response.msg)
                }
              }).catch((err)=>{
                this.toastMsg(err)
              })
            }
            
          }else{
            this.toastMsg('请确认签字后再提交！');
          }
        },
        toastMsg(msg) {
          Toast({message: msg, position: 'middle', duration: 3000});
        },
        //将base64格式图片转换成二进制形式
        base64ToBinary(base64String) {
          // 移除base64数据url前缀
          var base64Data = base64String.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
          
          // 将base64字符串转换为ArrayBuffer
          var binaryString = window.atob(base64Data);
          var length = binaryString.length;
          var bytes = new Uint8Array(length);
          
          for (var i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          
          // 创建Blob对象
          var blob = new Blob([bytes], { type: 'image/png' }); // 根据实际情况设置图片类型
          
          // 将Blob对象转换为二进制形式
          return blob;
        }
      },
      computed:{
          ...mapState({
            SelectSignature:state=>state.SelectSignature.SelectSignature
          }),
      },
      watch:{
        "SelectSignature":{
          deep:true,
          handler(newVal,oldVal){
              if(this.$route.params.signStatus=='0'){
                this.$refs.esign.reset();  //签字区重置
                this.bgPic=newVal     //未签字页面的原图片
              }else{
                this.makePic=newVal //查看已签字的签字照片
              }
          }
        }
      },
      
    };
  </script>
  
  <style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "../assets/scss/base.scss";
  
    $commonWhite: #fff5d7;
    $topColor: #e6c590;
    $bottomColor: #ddb375;
  
    .base-bg {
      width: 100%;
      @include bg-img('../assets/img/common/Bg');
      .nav-bar {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: px2rem(174);
        .btn-wrapper {
          margin-left:px2rem(55);
          padding-top: px2rem(86);
          text-align: center;
        }
      }
  
      .content-block {
        margin: 0 px2rem(28);
        height: px2rem(1004);
        width: px2rem(704);
        padding: px2rem(58) px2rem(55) 0 px2rem(55);
        box-sizing: border-box;
        @include bg-img('../assets/img/common/parentbgbase');
  
        .desc-block {
          color: white;
          p {
            font-family: 'SXSLST';
            font-size: px2rem(28);
            @include text-shadow(1, 1, rgba(159, 99, 34, 0.7));
          }
          textarea {
            display: block;
            width: 100%;
            height: px2rem(100);
            box-sizing: border-box;
            padding: px2rem(12);
            color: white;
            border: none;
            resize: none;
            background-color: transparent;
            line-height: 1.2;
            appearance: none;
            font-size: px2rem(20);
            &::-webkit-input-placeholder { /* WebKit browsers */
              color: white;
            }
            &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
              color: white;
            }
            &::-moz-placeholder { /* Mozilla Firefox 19+ */
              color: white;
            }
            &:-ms-input-placeholder { /* Internet Explorer 10+ */
              color: white;
            }
            &:focus {
              outline: 0;
              border: 0;
            }
          }
  
        }
  
        .img-block {
          margin-top: px2rem(35);
  
          .images {
            margin-top: px2rem(10);
          
            .btn-wrapper2{
              margin-top: px2rem(40);
              text-align: center;
            }
            .faBox{
                .box{
                  display: flex;
                  justify-content:space-between;
                  align-items: center;
                .textQian{
                    width: 30%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  span{
                    font-family: '宋体';
                    font-size: px2rem(24);
                    @include text-shadow(1, 1, rgba(159, 99, 34, 0.7));
                  }
                }
                .image{
                  width: 40%;
                  height: px2rem(200);
                  border: 1px solid lightgray;
                  border-radius: 10px;
                }
              }
              .boxEsign{
                  width: 100%;
                  height: 160px;
                }
              .btn{
                // margin-top: px2rem(40);
                margin-bottom:  px2rem(40);
                display: flex;
                justify-content: center;
                align-items: center;
                p{
                  color: black;
                  width: 100px;
                  height: 50px;
                  line-height: 50px;
                  background-color: white;
                }
              }
            }
          }
  
        }
      }
    }
  
  </style>
  


// WEBPACK FOOTER //
// signature.vue?6163dc19